import { Fetch } from "../apiConfig/Fetch";
import { ApiConfig } from "../apiConfig/apiConfig";

const ChallengersService = {
    insertOrUpdate: async (data) => {
        const { baseUrl, insertORUpdateChallengers } = ApiConfig;
        const url = baseUrl + insertORUpdateChallengers;

        return await Fetch(
            url,
            "POST",
            {},
            {
                userId: data.userId,
                title: data.title,
                id: data.id,
                detailTitle: data.detailTitle,
                url: data.url,
                toDate: data.toDate,
                fromDate: data.fromDate,
                description: data.description,
                imagesUrl: data.imagesUrl,
                date: data.date,
                keyTakeAways: data.keyTakeAways,
                websiteSource: data.websiteSource,
            },
            "services_challengersService",
            true
        );
    },

    getChallengersList: async () => {
        const { baseUrl, getChallengersList } = ApiConfig;
        const url = baseUrl + getChallengersList;

        return await Fetch(
            url,
            "GET",
            {},
            null,
            "services_getChallengersList"
        );
    },

    enableDisableChallenges: async (data) => {
        const { baseUrl, enableDisableChallenges } = ApiConfig;
        const url = baseUrl + enableDisableChallenges;

        return await Fetch(
            url,
            "POST",
            {},
            {
                userId: data.userId,
                id: data.id,
                status: data.status,
            },
            "services_enableDisableChallengers",
            true
        );
    },
};

export default ChallengersService;
